import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Btn, Cnpj, CustomModal , CustomDataTable} from '../../../../../components'
import * as ClientHttp from '../../../../../services/api/https/registration/client.http'
import { errorHandler } from '../../../../../services/util/error.service'

const styles = {
  clienteAssociado: {
    background: '#f0fafb',
    border: '1px solid #14B0BF',
    borderRadius: 4,
    padding: '10px 14px',
    marginBottom: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  clienteNome: {
    color: '#14B0BF',
    fontWeight: 600,
    fontSize: '0.9rem',
  },
  semCliente: {
    color: '#aaa',
    fontStyle: 'italic',
    fontSize: '0.85rem',
    marginBottom: 14,
  },
  btnDesassociar: {
    marginLeft: 10,
  },
  tableHeader: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    width: '100%',
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 14,
  },
}

function ModalAssociarClienteCanhoto({ isVisible, canhotoLabel, canhotoId, clienteAssociado, onClose, onSave, selectedTp }) {
  const [clientes, setClientes] = useState([])
  const [clienteSelecionado, setClienteSelecionado] = useState(null)
  const [globalFilter, setGlobalFilter] = useState('')
  const [loadError, setLoadError] = useState(null)

  useEffect(() => {
    if (isVisible) {
      setClienteSelecionado(clienteAssociado || null)
      setGlobalFilter('')
      setLoadError(null)
      ClientHttp.getClients(selectedTp)
        .then(data => setClientes(data))
        .catch(err => setLoadError(errorHandler(err)))
    }
  }, [isVisible])

  const handleRowClick = (e) => {
    setClienteSelecionado(e.data)
  }

  const handleDesassociar = () => {
    setClienteSelecionado(null)
  }

  const handleSalvar = () => {
    onSave(canhotoId, clienteSelecionado)
  }

  const tableHeader = (
    <div style={styles.tableHeader}>
      <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }} />
      <InputText
        type="search"
        onInput={e => setGlobalFilter(e.target.value)}
        placeholder="Pesquisar . . ."
        size="40"
      />
    </div>
  )

  return (
    <CustomModal
      isVisible={isVisible}
      header={`Associar Cliente a Canhoto - NF: ${canhotoLabel}`}
      width={860}
      onClose={onClose}
    >
      <div>
        <div style={{ fontSize: '0.8rem', color: '#14B0BF', marginBottom: 6 }}>
          Cliente associado:
        </div>
        {clienteSelecionado ? (
          <div style={styles.clienteAssociado}>
            <span style={styles.clienteNome}>{clienteSelecionado.nomeFantasia}</span>
            <Btn onClick={handleDesassociar}>Desassociar</Btn>
          </div>
        ) : (
          <div style={styles.semCliente}>Nenhum cliente associado</div>
        )}

        {loadError && (
          <div style={{ color: 'red', marginBottom: 10, fontSize: '0.85rem' }}>{loadError}</div>
        )}

        <CustomDataTable
          value={clientes}
          paginator={true}
          rows={6}
          header={tableHeader}
          globalFilter={globalFilter}
          selectionMode="single"
          onRowClick={handleRowClick}
          style={{ cursor: 'pointer' }}
        >
          <Column field="nomeFantasia" header="Nome Fantasia" />
          <Column
            field="cnpj"
            header="CNPJ/CPF"
            body={row => <Cnpj>{row.cnpj}</Cnpj>}
            style={{ width: 160 }}
          />
          <Column field="city" header="Cidade" style={{ width: 140 }} />
          <Column field="state" header="Estado" style={{ width: 80 }} />
        </CustomDataTable>

        <div style={styles.footer}>
          <Btn onClick={handleSalvar}>Salvar</Btn>
        </div>
      </div>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(ModalAssociarClienteCanhoto)
